import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { AvailableChapels } from "../../types/chapel";
import { OrderOption } from "../../types/order";
import { selectedOptionChapel, selectedSortOption } from "../../initial-state/initial-state";

interface OrderState {
    selectedOptionChapel: AvailableChapels;
    selectedSortOption: OrderOption;
    isOpenOption: boolean;
}

const initialState: OrderState = {
    selectedOptionChapel: selectedOptionChapel,
    selectedSortOption: selectedSortOption,
    isOpenOption: false
};

const orderSlice = createSlice({
    name: "order",
    initialState,
    reducers: {
        setSelectedOptionChapel: (state, action: PayloadAction<AvailableChapels>) => {
            state.selectedOptionChapel = action.payload;
        },

        setSelectedSortOption: (state, action: PayloadAction<OrderOption>) => {
            state.selectedSortOption = action.payload;
        },

        setOpenOption:(state, action: PayloadAction<boolean>) => {
            state.isOpenOption = action.payload
        },

        clearOrderState: () => initialState,
    },
});

export const {
    setSelectedOptionChapel,
    setSelectedSortOption,
    setOpenOption,
    clearOrderState,
} = orderSlice.actions;

export default orderSlice.reducer;

export const selectSelectedOptionChapel = (state: RootState) => state.order.selectedOptionChapel;
export const selectSelectedOptionChapelName = (state: RootState) => state.order.selectedOptionChapel.chapelName;
export const selectSelectedOptionChapelId = (state: RootState) => state.order.selectedOptionChapel.chapelID;

export const selectOption = (state: RootState) => state.order.selectedSortOption;
export const selectOptionName = (state: RootState) => state.order.selectedSortOption.name;
export const selectOptionId = (state: RootState) => state.order.selectedSortOption.id;

export const selectIsOption = (state: RootState) => state.order.isOpenOption;